import React, {useState} from 'react';
import NoDataRow from "../../../../../../components/reports/no-data-row.jsx";
import {translate} from "../../../../../../components/translate/translate.jsx";
import ReportUtils from "../../../../../../utils/report-utils.js";
import {navigateHook} from "../../../../../../hooks/use-navigate.js";

const BosListContent = ({ data, boName }) => {
    const navigate = navigateHook();
    const bos_list = data?.bos_list ?? [];

    const [limit, setLimit] = useState(10)
    const passedLimit = bos_list.length > limit;

    const seeMoreOrLess = () => {
        setLimit(prevState => prevState ? null : 10)
    }

    return (
        <>
            <div className="mt-4 mb-6 table-div">
                <span className="table-title mb-2">Lista de {boName} {(passedLimit && limit) ? ` (TOP ${limit})` : ''}</span>

                <table id="bos-list-data" className="table report-table mt-2" sheet-name={`Lista de ${boName}`}>
                    <thead className="thead-background">
                        <tr className="text-left">
                            <th className="w-[10%]">{boName}</th>
                            <th className="w-[14%]">Status</th>
                            <th className="w-[12%]">D/H do fato</th>
                            <th className="w-[12%]">Cadastrado por</th>
                            <th className="w-[12%]">Aprovado por</th>
                            <th className="w-[10%]">Flagrante</th>
                            <th className="w-[30%]">Naturezas</th>
                        </tr>
                    </thead>

                    <tbody>
                        { !bos_list?.length ? (
                            <NoDataRow colSpan={6} message={"Nenhum registro encontrado."} tdClassName="" alertClassName=""/>
                        ) : (limit ? bos_list.slice(0, limit) : bos_list).map((element, index) => {
                            const url = `/bo/redirect/${element.id?.replace('/', '-')}`;

                            return (
                                <>
                                    <tr key={index}>
                                        <td className="w-[10%]"><a onClick={() => navigate(url, true)} className={'inner-link'}>{element.id ?? ""}</a></td>
                                        <td className="w-[14%]">{translate(element.status) ?? ""}</td>
                                        <td className="w-[12%]">{element.dt_fact ?? ""}</td>
                                        <td className="w-[12%]">{ReportUtils.formatText(element.register) ?? ""}</td>
                                        <td className="w-[12%]">{ReportUtils.formatText(element.approve) ?? ""}</td>
                                        <td className="w-[10%]">{translate(element.flagrant) ?? ""}</td>
                                        <td className="w-[30%]">{element.reason ?? ""}</td>
                                    </tr>
                                </>
                            );
                        })}
                    </tbody>
                </table>

                { passedLimit &&
                    <div className="text-end mt-1">
                        <span className="see-more print-hide" onClick={seeMoreOrLess} style={{ cursor: "pointer" }}>
                            {limit ? "Ver mais" : "Ver menos"}
                        </span>
                    </div>
                }

            </div>
        </>
    );
};

export default BosListContent;
